<div class="mainContent">
    <div class="pageHeader" i18n>Configuration</div>

    <div class="itemsRow">
          <mat-card class="itemCard">
            <mat-card-header class="itemContent">
              <mat-icon>room_preferences</mat-icon>
              <mat-card-title class="itemHeader" i18n>Building Colors</mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <mat-card-subtitle class="itemDescription" i18n>Set custom colors for buildings</mat-card-subtitle>
              <mat-divider></mat-divider>
            </mat-card-content>
            <mat-card-footer class="itemAction" (click)="onBuildingTypeClicked()" i18n>SET</mat-card-footer>
          </mat-card>

          <mat-card class="itemCard">
            <mat-card-header class="itemContent">
              <mat-icon>list_alt</mat-icon>
              <mat-card-title class="itemHeader" i18n>Redlining Presets</mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <mat-card-subtitle class="itemDescription" i18n>Define presets for redlining</mat-card-subtitle>
              <mat-divider></mat-divider>
            </mat-card-content>
            <mat-card-footer class="itemAction" (click)="onRedliningPresetClicked()" i18n>SET</mat-card-footer>
          </mat-card>

          <mat-card class="itemCard">
            <mat-card-header class="itemContent">
              <mat-icon>person_add</mat-icon>
              <mat-card-title class="itemHeader" i18n>New user</mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <mat-card-subtitle class="itemDescription" i18n>Create a new user</mat-card-subtitle>
              <mat-divider></mat-divider>
            </mat-card-content>
            <mat-card-footer class="itemAction" (click)="addNewUser()" i18n>CREATE</mat-card-footer>
          </mat-card>

          <!-- <mat-card class="itemCard">
            <mat-card-header class="itemContent">
              <mat-icon>settings_applications</mat-icon>
              <mat-card-title class="itemHeader" i18n>Advanced Cache</mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <mat-card-subtitle class="itemDescription" i18n>Choose advanced cache settings</mat-card-subtitle>
              <mat-divider></mat-divider>
            </mat-card-content>
            <mat-card-footer class="itemAction" (click)="advancedCache()" i18n>SET</mat-card-footer>
          </mat-card> -->
    </div>

    <div class="itemsRow separation" *ngIf ="showPremium">
      <mat-card class="itemCard">
        <mat-card-header class="itemContent">
          <mat-icon>cached</mat-icon>
          <mat-card-title class="itemHeader">DB Precache</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <mat-card-subtitle class="itemDescription" i18n>Initiate precaching of database</mat-card-subtitle>
          <mat-divider></mat-divider>
        </mat-card-content>
        <mat-card-footer class="itemAction" (click)="openPreCacheInfo()">STATUS</mat-card-footer>
      </mat-card>

      <mat-card class="itemCard">
        <mat-card-header class="itemContent">
          <mat-icon>storage</mat-icon>
          <mat-card-title class="itemHeader" i18n>Update Schema</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <mat-card-subtitle class="itemDescription" i18n>Execute refresh schema</mat-card-subtitle>
          <mat-divider></mat-divider>
        </mat-card-content>
        <mat-card-footer class="itemAction" (click)="initiateRefreshSchema()">STATUS</mat-card-footer>
      </mat-card>

      <mat-card class="itemCard">
        <mat-card-header class="itemContent">
          <mat-icon>home_work</mat-icon>
          <mat-card-title class="itemHeader" i18n>Rack Cache</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <mat-card-subtitle class="itemDescription" i18n>Choose building types</mat-card-subtitle>
          <mat-divider></mat-divider>
        </mat-card-content>
        <mat-card-footer class="itemAction" (click)="chooseBuildingtypes()" i18n>SELECT</mat-card-footer>
      </mat-card>
    </div>

    <div class="pageOverlay" *ngIf="inProgress">
      <mat-spinner strokeWidth="6" [value]="value"></mat-spinner>
    </div>
</div>